import { useEffect } from "react";
import EndPoints from "src/Constants/EndPoints";
import useApiFetch from "../Shared/useApiFetch";
function useStateCity(state_id: any) {
  const {
    data: stateApiResponse,
    status: stateStatus,
    refetch: refetchStateData,
  } = useApiFetch([EndPoints.states], {});
  const { Items: stateData = [] } = stateApiResponse?.data ?? {};
  const {
    data: cityApiResponse,
    status: cityStatus,
    refetch: refetchCityData,
  } = useApiFetch([`${EndPoints.cities}?state_id=${state_id}`], {
    enabled: false,
  });
  const { Items: cityData = [] } = cityApiResponse?.data ?? {};

  useEffect(() => {
    if (state_id) {
      refetchCityData();
    }
  }, [refetchCityData, state_id]);

  return {
    state_id,
    stateData,
    cityData,
    stateStatus,
    cityStatus,
    refetchStateData,
  };
}

export default useStateCity;
